<template lang="html">

	<div data="formacion" class="cv-part">
		<h2 @click="openedit" class="title" :edit="showedit" :empty="!!!info" :notedit="notEdit">Formación</h2>
		<template v-if="!!info">
			<div class="edit-options" :edit="showedit && !!!el.esic" v-for="el in info" v-if="info.length != 0">
				<button class="editar" @click="setEditEstudio(el)">Editar</button>
				<button class=" eliminar" @click="eraseEstudio(el.id)">✕</button>
				<p :edit="showedit" class="experiencia">
					{{el.anioinicio}} - {{el.aniofin}}. <strong>{{el.titulo}}</strong>. {{el.centro}}
				</p>
			</div>
		</template>
		<template v-if="!!!info || info.length == 0">
			<p>Aún no tienes estudios añadidos, pulsa en añadir estudios para añadirlos</p>
		</template>
		<button class="btn skull" @click="setnew">+ Añadir estudios</button>


		<div class="cover-popup row-center" v-if="showadd">
			<div class="popup">
				<a class="close" @click="showadd = false">✕</a>
				<h2 class="title-pop">
					{{(!!!newestudio.id) ? 'Añadir formación' : 'Editar formación'}}
				</h2>

				<label for="">Título</label>
				<input type="text" name="titulo" v-validate="'required'" v-model="newestudio.titulo"
					placeholder="Título" :error="errors.has('titulo')">
				<span class="error animated shake" v-if="errors.has('titulo')">{{ errors.first('titulo') }}</span>

				<div class="contenedor-fechas row-center ais">

					<div class="datepicker-container" :error="errors.has('fechainicio')">
						<label for="">Desde</label>
						<datepicker :placeholder="'Fecha de Inicio'" :language="es" :full-month-name="true"
							:monday-first="true" :format="'MMMM yyyy'" :minimum-view="'month'" v-model="fechainicio"
							v-validate="'required'" :required="true" name="fechainicio"></datepicker>
						<span class="error animated shake"
							v-if="errors.has('fechainicio')">{{ errors.first('fechainicio') }}</span>
					</div>

					<div class="datepicker-container" :actualidad="newestudio.actualidad"
						:error="errors.has('fechafin')">
						<label for="">Hasta</label>
						<div class="toggle-checkbox" :edit="showadd">
							<input type="checkbox" id="actualidad" v-model="newestudio.actualidad" @change="validateDate">
							<label for="actualidad">Actualidad</label>
						</div>
						<datepicker :disabled="!!newestudio.actualidad" :placeholder="'Fecha de Fin'" :language="es"
							:full-month-name="true" :monday-first="true" :format="'MMMM yyyy'" :minimum-view="'month'"
							v-model="fechafin" v-validate="(!!!newestudio.actualidad) ? 'required' : ''"
							name="fechafin"></datepicker>
						<span class="error animated shake"
							v-if="errors.has('fechafin')">{{ errors.first('fechafin') }}</span>
					</div>
				</div>

				<label for="">Nivel de Estudios</label>
				<select v-model="newestudio.idNivel" v-validate="'required'" name="nivel" :error="errors.has('nivel')">
					<option value="">Selecciona un nivel</option>
					<option v-for="(nivel,key) in dominiosorder.nivelEstudios" :value="nivel[0]">{{nivel[1]}}</option>
				</select>
				<span class="error animated shake" v-if="errors.has('nivel')">{{ errors.first('nivel') }}</span>

				<label for="">Ambito</label>
				<select v-model="newestudio.idAmbito" v-validate="'required'" name="ambito"
					:error="errors.has('ambito')" @change="newestudio.idEspecialidad = ''">
					<option value="">Selecciona un ámbito</option>
					<option v-for="(ambito,key) in dominiosorder.ambitoEstudios" :value="ambito[0]">{{ambito[1]}}
					</option>
				</select>
				<span class="error animated shake" v-if="errors.has('ambito')">{{ errors.first('ambito') }}</span>

				<label for="">Especialidad</label>
				<select v-model="newestudio.idEspecialidad" v-validate="'required'" name="especialidad"
					:error="errors.has('especialidad')">
					<option value="">Selecciona una especialidad</option>
					<option v-for="(especialidad,key) in especialidadFilter" :value="especialidad[0].split('_').pop()">
						{{especialidad[1]}}</option>
				</select>
				<span class="error animated shake"
					v-if="errors.has('especialidad')">{{ errors.first('especialidad') }}</span>

				<label for="">Centro de estudios</label>
				<input type="text" name="centro" v-validate="'required'" v-model="newestudio.centro"
					placeholder="Centro de estudios" :error="errors.has('centro')">
				<span class="error animated shake" v-if="errors.has('centro')">{{ errors.first('centro') }}</span>

				<label for="">Nota</label>
				<input type="text" name="nota" v-validate="'required'" v-model="newestudio.nota"
					placeholder="Calificación final" :error="errors.has('nota')">
				<span class="error animated shake" v-if="errors.has('nota')">{{ errors.first('nota') }}</span>

				<button class="btn" @click="checkestudio" :loading="loading">
					{{(!!!newestudio.id) ? 'Añadir estudios' : 'Editar estudios'}}
				</button>


			</div>
		</div>


	</div>

</template>

<script lang="js">

	import { mapActions, mapGetters } from 'vuex';

	import { es } from 'vuejs-datepicker/dist/locale';

	import Datepicker from 'vuejs-datepicker';

	import Vue from 'vue';
	import VeeValidate from 'vee-validate';
	import { Validator } from "vee-validate";

	Vue.use(VeeValidate);

	export default {
		props: ['info'],
		name: 'formacion-cv',
		data() {
			return {
				showadd: false,
				showedit: false,
				loading: false,
				newestudio: {
					titulo: '',
					mesinicio: '',
					anioinicio: '',
					mesfin: '',
					aniofin: '',
					idNivel: '',
					idAmbito : '',
					idEspecialidad : '',
					especialidades: [],
					nota: '',
					actualidad: false
				},
				fechafin: '',
				fechainicio: '',
				es: es,
			}
		},
		methods: {
			...mapActions(['eraseEstudio', 'addEstudio', 'editEstudio', 'canEditCv']),
			checkestudio() {

				this.$validator.validateAll().then(canSend => {
					if (canSend) {
						this.loading = true;
						this.setFecha();

						let especialidad = {
							'idAmbito': this.newestudio.idAmbito,
							'idEspecialidad': this.newestudio.idEspecialidad,
						};

						this.newestudio.especialidades = [especialidad];

						if (!!!this.newestudio.id) {
							this.addEstudio(this.newestudio).then(r => {
								if (r) {
									this.loading = false;
									this.showadd = false;
								}
							});
						} else {
							this.editEstudio(this.newestudio).then(r => {
								if (r) {
									this.loading = false;
									this.showadd = false;
								}
							});
						}
					}

				});
			},
			validateDate(){
				this.$validator.validate('fechafin');
			},	
			setnew() {
				this.canEditCv().then(r => {
					(r) ? this.showadd = true : '';
					this.reset();
				});
			},
			openedit() {
				if(!this.notEdit){
				this.canEditCv().then(r => {
					if(!!!this.info){
            			(r) ? this.showadd = !this.showadd : '';
          			}else{
            			(r) ? this.showedit = !this.showedit : '';
        			}
				});
				}
			},
			setEditEstudio(el) {
				this.showadd = true;
				this.newestudio = JSON.parse(JSON.stringify(el));

				this.newestudio.idAmbito = this.newestudio.especialidades[0].idAmbito
				this.newestudio.idEspecialidad = this.newestudio.especialidades[0].idEspecialidad

				this.fechainicio = new Date(this.newestudio.anioinicio, this.newestudio.mesinicio - 1);
				this.attached = (!!this.newestudio.adjunto);
				if (this.newestudio.aniofin == 'Actualidad') {
					this.newestudio.actualidad = true;
				} else {
					this.fechafin = new Date(this.newestudio.aniofin, this.newestudio.mesfin - 1);
				}
			},
			setFecha() {
				if (!!this.newestudio.actualidad) {
					this.newestudio.mesfin = 'Actualidad';
					this.newestudio.aniofin = 'Actualidad';
				} else if (!!this.fechafin) {
					let fechafin = new Date(this.fechafin);
					this.newestudio.mesfin = fechafin.getMonth() + 1;
					this.newestudio.aniofin = fechafin.getFullYear();
				}

				let fechainicio = new Date(this.fechainicio);
				this.newestudio.mesinicio = fechainicio.getMonth() + 1;
				this.newestudio.anioinicio = fechainicio.getFullYear();

			},
			reset() {
				for (let i in this.newestudio) {
					if (typeof (this.newestudio[i]) != 'object') {
						this.newestudio[i] = ''
					} else {
						for (let j in this.newestudio[i]) {
							this.newestudio[i][j] = ''
						}
					}
				}
				this.fechafin = '';
				this.fechainicio = '';
			}
		},
		components: {
			Datepicker
		},
		computed: {
			...mapGetters({
				dominios: 'getDominios'
			}),
			dominiosorder() {
				let dominios = new Object();
				if (!!this.dominios) {
					let toorder = ['nivelEstudios', 'ambitoEstudios', 'especialidadEstudios'];
					toorder.forEach(e => {
						let tipos = Object.entries(this.dominios[e]);
						dominios[e] = tipos.sort(function (p1, p2) {
							return (p1[1] < p2[1]) ? -1 : 1;
						})
					});
				}
				return dominios;
			},
			especialidadFilter() {

				let especialidades = new Array();

				if (!!this.dominiosorder && !!this.newestudio.idAmbito) {

					let ambito = this.newestudio.idAmbito;

					this.dominiosorder.especialidadEstudios.forEach(e => {
						if (e[0].includes(ambito + '_')) {
							especialidades.push(e);
						}
					});

				}

				return especialidades;
			},
			notEdit(){
				if(!!this.info){
					return (this.info.filter(e => e.esic).length == this.info.length);
				}
			}
		}
	}
</script>

<style scoped lang="scss">
	select,
	textarea {
		margin-bottom: 20px;

		&[aria-invalid=true] {
			margin-bottom: 0;
		}
	}

	input {
		width: 100%;
		margin-bottom: 20px;

		&[aria-invalid=true] {
			margin-bottom: 0;
		}
	}

	 @media screen and (max-height: 900px){
    .cover-popup .popup{
      overflow: scroll;
      overflow-x: hidden;
      max-height: 90vh;
    }
  }

	@media screen and (max-width: 440px) {

		input,
		select,
		textarea {
			margin-bottom: 10px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/views/mi-cv/formacion.vue